import axios from "axios"

const axiosApiInstance = axios.create({
	baseURL: process.env.REACT_APP_DB_ADDRESS
})

const AxiosControl = () => {
	axiosApiInstance.interceptors.response.use(response => {
		return response
	 }, error => {
		if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === "Invalid JWT Token") {
			localStorage.removeItem("jwt")
			window.location.pathname = ''
		}
		return Promise.reject(error)
	 })

	return axiosApiInstance
}

export default AxiosControl
